import React from "react";
import { TextField, MenuItem } from "@mui/material";
import { useSelector } from "react-redux";
import { selectUniqueSuburbs } from "../store/propertiesSelectors";

interface SuburbInputProps {
  value: string;
  onChange: (suburb: string) => void;
  disabled?: boolean;
  size?: "small" | "medium";
}

export const SuburbInput: React.FC<SuburbInputProps> = ({
  value,
  onChange,
  disabled = false,
  size = "medium",
}) => {
  const suburbs = useSelector(selectUniqueSuburbs);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <TextField
      margin="dense"
      label="Suburb"
      fullWidth
      size={size}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      select
      data-testid="suburb-input"
    >
      <MenuItem value="">
        <em>All suburbs</em>
      </MenuItem>
      {suburbs.map((suburb) => (
        <MenuItem key={suburb} value={suburb}>
          {suburb}
        </MenuItem>
      ))}
    </TextField>
  );
};